import { useMemo } from 'react';
import { t } from '@lingui/core/macro';
import { Gauge } from 'lucide-react';

import { StudentRecentPaceStatus } from '@duke-hq/svc-api-db';
import { MultipleChoiceFilter } from '@duke-hq/ui/components/MultipleChoice/MultipleChoiceFilter';

import useFiltersContext from '@duke-hq/filters/context/useFiltersContext';

export default function FourteenDayPaceFilter() {
  const { updateFilters, filters } = useFiltersContext();

  const options = useMemo(() => {
    return [
      {
        id: StudentRecentPaceStatus.GREAT.toLowerCase(),
        value: StudentRecentPaceStatus.GREAT.toLowerCase(),
        label: t`Great`,
      },
      {
        id: StudentRecentPaceStatus.GOOD.toLowerCase(),
        value: StudentRecentPaceStatus.GOOD.toLowerCase(),
        label: t`Good`,
      },
      {
        id: StudentRecentPaceStatus.SLOW.toLowerCase(),
        value: StudentRecentPaceStatus.SLOW.toLowerCase(),
        label: t`Slow`,
      },
      {
        id: StudentRecentPaceStatus.NONE.toLowerCase(),
        value: StudentRecentPaceStatus.NONE.toLowerCase(),
        label: t`None`,
      },
    ];
  }, []);

  const selected = useMemo(() => {
    const paceValues = filters.recentPaceStatus ?? [];
    const validIds = new Set(options.map(({ id }) => id));
    return paceValues.filter((id) => validIds.has(id));
  }, [filters.recentPaceStatus, options]);

  return (
    <MultipleChoiceFilter
      items={options}
      label={t`14-day pace`}
      name="recentPaceStatus"
      onFilterChange={({ recentPaceStatus }) => {
        updateFilters({ recentPaceStatus });
      }}
      onlyUpdateOnChange
      value={selected.join(',')}
      variant="ghost"
      leftIcon={<Gauge size="16px" />}
      rightIcon={undefined}
    />
  );
}
